export default async function RestChipDataService() {
  const endpoint = "/api/selectedServices";

  try {
    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    return res.clone();
  } catch (res_1) {
    return "false";
  }
}
